// Contract between SegmentedControlDirective and components/_segmented-control.scss.
export const SEGMENTED_CONTROL_THUMB_X_PROPERTY = '--seg-x';
export const SEGMENTED_CONTROL_THUMB_WIDTH_PROPERTY = '--seg-w';
// Set while a pressed segment exists and the thumb is positioned under it.
export const SEGMENTED_CONTROL_THUMB_CLASS = 'has-thumb';
// Set one frame after the first measurement, so the thumb appears in place instead of sliding in.
export const SEGMENTED_CONTROL_READY_CLASS = 'is-ready';
export const SEGMENTED_CONTROL_PRESSED_SELECTOR = 'button[aria-pressed="true"]';
